import {
  OverallGoalAssessmentAnswerNode,
  OverallGoalAssessmentQuestionNode,
  OverallRecognitionCoreValueAssessmentAnswerNode,
  OverallRecognitionCoreValueAssessmentQuestionNode,
  RangeAssessmentAnswerNode,
  RangeAssessmentQuestionNode,
  TalentIndicatorAssessmentAnswerNode,
  TalentIndicatorAssessmentQuestionNode,
} from "types/graphql-schema";

import {
  AssessmentReportFilterMatchType,
  AssessmentReportViewOptions,
} from "./assessment-report/report-filters/types";

type AssessmentReportQuestion =
  | Partial<RangeAssessmentQuestionNode>
  | Partial<TalentIndicatorAssessmentQuestionNode>
  | Partial<OverallGoalAssessmentQuestionNode>
  | Partial<OverallRecognitionCoreValueAssessmentQuestionNode>;
export const isAssessmentReportQuestionType = (
  // type gate function so `any` is acceptable here
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  question: any
): question is AssessmentReportQuestion => {
  return (
    question.__typename === "RangeAssessmentQuestionNode" ||
    question.__typename === "TalentIndicatorAssessmentQuestionNode" ||
    question.__typename === "OverallGoalAssessmentQuestionNode" ||
    question.__typename === "OverallRecognitionCoreValueAssessmentQuestionNode"
  );
};

type AssessmentReportAnswer =
  | Partial<RangeAssessmentAnswerNode>
  | Partial<TalentIndicatorAssessmentAnswerNode>
  | Partial<OverallGoalAssessmentAnswerNode>
  | Partial<OverallRecognitionCoreValueAssessmentAnswerNode>;
export const isAssessmentReportAnswerType = (
  // type gate function so `any` is acceptable here
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  answer: any
): answer is AssessmentReportAnswer => {
  return (
    answer.__typename === "RangeAssessmentAnswerNode" ||
    answer.__typename === "TalentIndicatorAssessmentAnswerNode" ||
    answer.__typename === "OverallGoalAssessmentAnswerNode" ||
    answer.__typename === "OverallRecognitionCoreValueAssessmentAnswerNode"
  );
};

export const initAssessmentReportViewOptions: AssessmentReportViewOptions = {
  id: null,
  name: "New View",
  isDirty: false,
  filters: {
    type: AssessmentReportFilterMatchType.MATCH_ALL,
    list: [],
  },
  tableColumns: [],
  hiddenRecentAnswers: [],
  nineBox: {
    selectedXQuestionIndex: 0,
    selectedYQuestionIndex: 1,
  },
};
